import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.414 10l6.293-6.293a.999.999 0 1 0-1.414-1.414L10 8.586 3.707 2.293a.999.999 0 1 0-1.414 1.414L8.586 10l-6.293 6.293a.999.999 0 1 0 1.414 1.414L10 11.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z",
  fillRule: "evenodd"
});

var SvgMobileCancelMajorMonotone = function SvgMobileCancelMajorMonotone(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgMobileCancelMajorMonotone as S };
